export default "/build/static/fonts/Whitney-BookItal_Web.woff2";